import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';

// Avisos de pedidos al celular (sql/119): cada persona los activa en SU
// celular/compu y, cuando cae un pedido del catálogo, le llega una notificación
// con sonido aunque Kontrol esté cerrado. En iPhone funciona solo con Kontrol
// instalado en la pantalla de inicio.

const API = '/api/cuenta?accion=aviso-pedido';

export const avisosSoportados = () => typeof window !== 'undefined'
  && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

const esIphone = () => /iPhone|iPad|iPod/i.test(navigator.userAgent || '');
const instalada = () => window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
// En iPhone sin instalar no hay avisos: hay que abrir Kontrol desde el ícono.
export const necesitaInstalar = () => esIphone() && !instalada();

function bytesDeLlave(base64) {
  const relleno = '='.repeat((4 - (base64.length % 4)) % 4);
  const b = atob((base64 + relleno).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...b].map((c) => c.charCodeAt(0)));
}

async function suscripcionActual() {
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

// 'activados' | 'bloqueados' | 'apagados' | 'no-soportado'
export async function estadoAvisos() {
  if (!avisosSoportados()) return 'no-soportado';
  if (Notification.permission === 'denied') return 'bloqueados';
  const sub = await suscripcionActual().catch(() => null);
  return sub && Notification.permission === 'granted' ? 'activados' : 'apagados';
}

export async function activarAvisos() {
  if (!avisosSoportados()) throw new Error('Este navegador no permite avisos.');
  const permiso = await Notification.requestPermission();
  if (permiso !== 'granted') throw new Error(permiso === 'denied' ? 'Bloqueaste los avisos. Actívalos en los ajustes del navegador.' : 'No diste permiso para los avisos.');
  const r = await fetch(API);
  const { publica } = await r.json();
  if (!publica) throw new Error('No se pudo preparar los avisos. Intenta de nuevo.');
  const reg = await navigator.serviceWorker.ready;
  const sub = (await reg.pushManager.getSubscription())
    || await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: bytesDeLlave(publica) });
  const j = sub.toJSON();
  const { error } = await supabase.from('push_suscripciones').insert({
    negocio_id: getNegocioId(), endpoint: j.endpoint, p256dh: j.keys.p256dh, auth: j.keys.auth, agente: (navigator.userAgent || '').slice(0, 300),
  });
  if (error && error.code !== '23505') throw error; // 23505 = ya estaba guardada
}

export async function desactivarAvisos() {
  const sub = await suscripcionActual().catch(() => null);
  if (!sub) return;
  await supabase.from('push_suscripciones').delete().eq('endpoint', sub.endpoint);
  await sub.unsubscribe().catch(() => {});
}

export async function probarAvisos() {
  const { data: { session } } = await supabase.auth.getSession();
  const r = await fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session?.access_token}` }, body: JSON.stringify({ prueba: true }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error('No se pudo mandar la prueba.');
  return d;
}

// Lo llama el catálogo después de crear un pedido (no espera respuesta).
export function avisarPedidoNuevo({ grupo, pedido }) {
  try {
    fetch(API, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(grupo ? { grupo } : { pedido }) }).catch(() => {});
  } catch (e) { /* el pedido ya quedó guardado */ }
}

// "Ding" corto para cuando Kontrol está abierto.
export function sonarAviso() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [[880, 0], [1320, 0.16]].forEach(([f, t]) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = 'sine'; o.frequency.value = f; o.connect(g); g.connect(ctx.destination);
      g.gain.setValueAtTime(0.0001, ctx.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.35, ctx.currentTime + t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.35);
      o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + 0.4);
    });
    setTimeout(() => ctx.close().catch(() => {}), 1200);
  } catch (e) { /* sin sonido */ }
}
